/**
 * Persist Google and Meta click IDs on the checkout session.
 * gclid comes from the landing URL; fbp/fbc come from first-party cookies.
 */

const SESSION_KEY = "rx_ad_click_ids";

const readCookie = (name) => {
  if (typeof document === "undefined") return "";
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : "";
};

const writeCookie = (name, value, maxAgeSeconds) => {
  if (typeof document === "undefined" || !value) return;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
};

const readSessionIds = () => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return {
      gclid: parsed.gclid || "",
      fbp: parsed.fbp || "",
      fbc: parsed.fbc || "",
    };
  } catch (err) {
    return { gclid: "", fbp: "", fbc: "" };
  }
};

const writeSessionIds = (ids) => {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(ids));
  } catch (err) {
    // ignore
  }
};

export const getSessionClickIds = () => {
  const stored = readSessionIds();
  return {
    gclid: stored.gclid || "",
    fbp: stored.fbp || readCookie("_fbp") || "",
    fbc: stored.fbc || readCookie("_fbc") || "",
  };
};

export const captureSessionClickIds = () => {
  if (typeof window === "undefined") return getSessionClickIds();

  const stored = readSessionIds();
  const params = new URLSearchParams(window.location.search);
  const gclid = params.get("gclid") || stored.gclid || "";
  const fbclid = params.get("fbclid");

  let fbc = readCookie("_fbc") || stored.fbc || "";
  if (fbclid && !fbc) {
    fbc = `fb.1.${Date.now()}.${fbclid}`;
    writeCookie("_fbc", fbc, 90 * 24 * 60 * 60);
  }

  const ids = {
    gclid,
    fbp: readCookie("_fbp") || stored.fbp || "",
    fbc,
  };
  writeSessionIds(ids);
  return ids;
};
